// Shared by the map page and the event place picker.
export const DEFAULT_MAP_CENTER: [number, number] = [10.7769, 106.7009];
export const OSM_TILE_URL = "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png";
export const OSM_ATTRIBUTION = '&copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a>';
